import React, { useEffect, useState } from "react";
import InputField from "../components/InputField";
import Button from "../components/Button";
import useTicket from "../hooks/useTicket";
import { currentPageAtom } from "../store";
import { useAtom } from "jotai";
import { validateInput } from "../utils";
import { useNavigate } from "react-router-dom";
import "react-tooltip/dist/react-tooltip.css";
import { Tooltip } from "react-tooltip";

const Home = () => {
  const [ticketId, setInputVal] = useState("");
  const [email, setEmail] = useState("");
  const { loading } = useTicket();
  const [page, setPage] = useAtom(currentPageAtom);

  useEffect(() => {
    resetPagination();
    document.title = "Ticket Tracker";
  }, []);

  const resetPagination = () => {
    // reset the pagination number if it isnt already at the first page
    if (page !== 1) setPage(1);
  };

  const navigate = useNavigate();

  const handleChange = (val: string) => {
    return validateInput(val, () => setInputVal(val));
  };

  const handleRouteChange = () => {
    if (email && ticketId) {
      navigate(`/tracking/?ticketID=${ticketId}&email=${email}`);
    }
  };

  const changeRouteOnEnterKey = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      if (email && ticketId) {
        navigate(`/tracking/?ticketID=${ticketId}&email=${email}`);
      }
    }
  };

  return (
    <div className="contain-expand main-content-container">
      <section className="main-content">
        <div>
          <a
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Enter the email address used in your request and input the Ticket Id of your request"
            className="home-tooltip"
          >
            <span>i</span>
          </a>
          <Tooltip id="my-tooltip" />
          <div className="main-content-text-box">
            <h1>Track your tickets</h1>
            <p>
              Enter your ticket ID to track status and engage on the ticket
              raised
            </p>
          </div>

          <div className="main-content-input-box">
            <InputField
              name="email"
              type={"text"}
              placeholder="Enter Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={(e) => changeRouteOnEnterKey(e)}
            />
            <p>and</p>
            <InputField
              value={ticketId}
              onChange={(e) => handleChange(e.target.value)}
              onKeyDown={(e) => changeRouteOnEnterKey(e)}
              placeholder={"Enter your ticket ID"}
            />
          </div>

          <div>
            <Button
              type="submit"
              onClick={handleRouteChange}
              disabled={!ticketId || ticketId === "" || !email || email === ""}
            >
              {" "}
              {loading ? "Tracking..." : "Track"}
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
